import { HelpIcon } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons';
import styled from 'styled-components';

const HelpIconStyled = styled(HelpIcon)`
  width: 24px;
  height: 24px;
  align-self: center;

  :hover {
    cursor: pointer;
  }
`;

const HelpHeaderTitleStyled = styled.span`
  display: none;
  @media (min-width: 769px) {
    display: inline;
    color: white;
    font-family: cerapro;
    font-size: 14px;
    line-height: 18px;
    margin-left: 7px;
    align-self: center;

    :hover {
      cursor: pointer;
    }
  }
`;

export { HelpIconStyled, HelpHeaderTitleStyled };
